import React from 'react'
import {SvgIcon} from 'rambler-ui'

export default function SettingsIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 25 25">
      <g fillRule="evenodd">
        <path
          fillRule="nonzero"
          d="M20.8 19.5c0-.276.224-.5.5-.5h.2c.276 0 .5.224.5.5v.5c0 1.105-.895 2-2 2H5c-1.105 0-2-.895-2-2v-9c0-1.105.895-2 2-2h15c1.105 0 2 .895 2 2v.5c0 .276-.224.5-.5.5h-.2c-.276 0-.5-.224-.5-.5V11c0-.408-.305-.744-.7-.794L20 10.2H5c-.408 0-.744.305-.794.7L4.2 11v9c0 .408.305.744.7.794l.1.006h15c.408 0 .744-.305.794-.7l.006-.1v-.5z"
        />
        <rect width="2" height="1.2" x="20" y="13" rx=".5" />
        <rect width="1.2" height="5" x="12" y="13" rx=".5" />
        <rect width="2" height="1.2" x="20" y="15" rx=".5" />
        <rect width="2" height="1.2" x="20" y="17" rx=".5" />
        <path
          fillRule="nonzero"
          d="M13 2c3.314 0 6 2.686 6 6v2h-1.2V8c0-2.58-2.034-4.683-4.586-4.795L13 3.2h-1c-2.58 0-4.683 2.034-4.795 4.586L7.2 8v2H6V8c0-3.314 2.686-6 6-6h1z"
        />
      </g>
    </SvgIcon>
  )
}
